'use client';

import { useEffect, useState } from 'react';
import { getAsset } from './assetStore';

// Session-lived object URLs, one per asset URL: repeated mounts reuse the same blob URL
// instead of re-reading IDB, and nothing is revoked mid-session (a handful of small files).
const objectUrls = new Map<string, Promise<string>>();

const storedImageSrc = (url: string): Promise<string> => {
  let p = objectUrls.get(url);
  if (!p) {
    // the store already falls back to a network fetch on a miss; if even that fails,
    // hand back the plain network URL so the <img> can try on its own
    p = getAsset(url).then((blob) => URL.createObjectURL(blob)).catch(() => url);
    objectUrls.set(url, p);
  }
  return p;
};

/** Blob-URL src for an image served through the asset store (IDB-cached — a TMA webview
 *  re-downloads plain network URLs every session). null until the blob is ready. */
export function useStoredImageSrc(url: string): string | null {
  const [src, setSrc] = useState<string | null>(null);
  useEffect(() => {
    let live = true;
    void storedImageSrc(url).then((s) => { if (live) setSrc(s); });
    return () => { live = false; };
  }, [url]);
  return src;
}
